import _ from 'lodash';
import moment from 'moment';

/**
 * Derives the one-minute strip window covering a list of ECG events in the viewer. Uses the events' startTimeEpoch minute as the base, extending ten seconds earlier when an event starts within the first ten seconds of the minute and ten seconds later when one starts past the fifty-second mark.
 *
 * @param events - The events the strip window must cover, read for start and startTimeEpoch.
 * @returns An object carrying the startStrip and stopStrip moments.
 */
export const calculateStartStopStripMomentOfListEvent = ({ events }: { events: any[] }) => {
  let startTimeEpoch;
  let isExtendStart;
  let isExtendStop;
  _.forEach(events, (event) => {
    startTimeEpoch = event?.startTimeEpoch;
    if (
      event?.start &&
      moment(event?.start).valueOf() > event.startTimeEpoch &&
      moment(event?.start).second() > 50
    ) {
      // *: End of ECG Viewer
      isExtendStop = true;
    } else if (event?.start && moment(event?.start).second() < 10) {
      // *: Start of ECG Viewer
      isExtendStart = true;
    }
  });
  const baseStartStrip = moment(startTimeEpoch).startOf('minutes');
  const startStrip = baseStartStrip.clone().subtract(isExtendStart ? 10 : 0, 'seconds');
  const stopStrip = baseStartStrip.clone().add(isExtendStop ? 70 : 60, 'seconds');
  return {
    startStrip,
    stopStrip,
  };
};

export const calculateStartStopStripMomentOfListEventV2 = ({
  startTimeEpoch,
}: {
  startTimeEpoch: any;
}) => {
  const baseStartStrip = moment(startTimeEpoch).startOf('minutes');
  const startStrip = baseStartStrip.clone().subtract(10, 'seconds');
  const stopStrip = baseStartStrip.clone().add(70, 'seconds');
  return {
    defaultStartStrip: startStrip,
    defaultStopStrip: stopStrip,
  };
};

/**
 * Checks that an ECG event's span is fully covered by an unbroken chain of loaded data ranges. Rejects an empty range list, or an event starting before the first range or ending after the last, then walks the ranges sorted by start and fails as soon as one range's stop does not exactly meet the next range's start.
 *
 * @param range - The loaded data ranges, each with a start and stop.
 * @param event - The event whose span must be covered.
 * @returns True when the sorted ranges are contiguous and enclose the event.
 */
export const isCheckContinueData = (range: any[], event: any) => {
  if (range?.length === 0) {
    return false;
  }
  const sortRange = _.sortBy(range, (x) => x.start);
  if (
    moment(event?.start).valueOf() < moment(sortRange[0].start).valueOf() ||
    moment(event?.stop).valueOf() > moment(sortRange[sortRange.length - 1].stop).valueOf()
  ) {
    return false;
  }
  let flags = true;
  for (let i = 0; i < sortRange.length - 1; i += 1) {
    if (!moment(sortRange[i].stop).isSame(moment(sortRange[i + 1].start))) {
      flags = false;
      break;
    }
  }
  return flags;
};
